export default __webpack_public_path__ + "static/media/CardImg2.fbfda853.png";